import React from "react";
import { useParams } from "react-router-dom";
import { useMedia } from "../contentServices";

import ManageMediaAccess from "../../common/ManageMediaAccess";
import PanelLoadingIndicator from "../../../components/PanelLoadingIndicator";

const ManageContentAccess = () => {
  const { id } = useParams();
  const content = useMedia(id);

  if (content.isLoading) {
    return <PanelLoadingIndicator />;
  }

  return <ManageMediaAccess media={content.data} />;
};

export default ManageContentAccess;
